require('./style.scss')
class PaginatorDirective
  constructor: ()->                
    class Paginator
      restrict: "E"
      require: ['^?restfulResources', '^?collectionResources', '^?devices', '^?deviceModal']
      template: require('./index.pug')
      link: ($scope, $element, attrs, controllers)->
        controller = null
        controllers.forEach (e)->
          if e isnt null 
            controller = e
        $scope.move = (page)->
          $scope.$parent.currentPage = page 
          controller.move page


    return new Paginator()

  
module.exports = PaginatorDirective


// WEBPACK FOOTER //
// ./src/common/resource/paginator/index.coffee